import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import * as IndirectRateCostCenterActions from './indirect-rate-cost-center.actions';
import { IndirectRateCostCenter } from './indirect-rate-cost-center.model';

export const indirectRateCostCentersFeatureKey = 'indirectRateCostCenters';

export interface State extends EntityState<IndirectRateCostCenter> {
    // additional entities state properties
}

export const adapter: EntityAdapter<IndirectRateCostCenter> =
    createEntityAdapter<IndirectRateCostCenter>();

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const indirectRateCostCenterReducer = createReducer(
    initialState,
    on(
        IndirectRateCostCenterActions.addIndirectRateCostCenter,
        (state, action) => adapter.addOne(action.indirectRateCostCenter, state)
    ),
    on(
        IndirectRateCostCenterActions.upsertIndirectRateCostCenter,
        (state, action) =>
            adapter.upsertOne(action.indirectRateCostCenter, state)
    ),
    on(
        IndirectRateCostCenterActions.addIndirectRateCostCenters,
        (state, action) =>
            adapter.addMany(action.indirectRateCostCenters, state)
    ),
    on(
        IndirectRateCostCenterActions.upsertIndirectRateCostCenters,
        (state, action) =>
            adapter.upsertMany(action.indirectRateCostCenters, state)
    ),
    on(
        IndirectRateCostCenterActions.updateIndirectRateCostCenter,
        (state, action) =>
            adapter.updateOne(action.indirectRateCostCenter, state)
    ),
    on(
        IndirectRateCostCenterActions.updateIndirectRateCostCenters,
        (state, action) =>
            adapter.updateMany(action.indirectRateCostCenters, state)
    ),
    on(
        IndirectRateCostCenterActions.deleteIndirectRateCostCenter,
        (state, action) => adapter.removeOne(action.id, state)
    ),
    on(
        IndirectRateCostCenterActions.deleteIndirectRateCostCenters,
        (state, action) => adapter.removeMany(action.ids, state)
    ),
    on(
        IndirectRateCostCenterActions.loadIndirectRateCostCenters,
        (state, action) => adapter.setAll(action.indirectRateCostCenters, state)
    ),
    on(IndirectRateCostCenterActions.clearIndirectRateCostCenters, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return indirectRateCostCenterReducer(state, action);
}
